import { ApiStatus } from '../../types';
import {
    liabilitiesDefaultContent,
    OtherLiabilitiesApiEndPoints,
    OtherLiabilitiesDefaultContent,
    OtherLiabilitiesState,
} from './otherLiabilitiesTypes';

export const initialStateOtherLiabilities: OtherLiabilitiesState = {
    content: liabilitiesDefaultContent,
    otherLiabilities: {},
    lastVisitedItem: {
        id: null,
        mode: null,
        isSaved: false,
    },
    referenceData: {
        financialInstitutions: [],
        liabilityShareOptions: [],
        liabilityTypes: [],
        repaymentFrequencies: [],
    },
    isAddMode: false,
    apiStatus: ApiStatus.Idle,
    apiEndPoints: {
        getLiabilitiesUrl: '/getOtherLiabilities',
        updateLiabilitiesUrl: '/updateOtherLiabilities',
    },
};

export const getLiabilitiesPreloadData = (
    apiEndPoints: OtherLiabilitiesApiEndPoints,
    aem?: OtherLiabilitiesDefaultContent,
): OtherLiabilitiesState => (
    aem
        ? { ...initialStateOtherLiabilities, apiEndPoints, content: aem }
        : { ...initialStateOtherLiabilities, apiEndPoints }
);
